import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
	setAbsThreshold,
	setNewPreferences,
	setRaisesColors,
} from '../../../../../Redux/slices/Preferences/preferences'
import { useCurrentTheme } from '../../../../../hooks/useCurrentTheme'
import ColorPickerControl from './ColorPicker'
import { useComponentLocale } from '../../../../../hooks/useComponentLocale'
import { Input, Switch, Typography } from 'antd'
import { useActions } from '../../../../../hooks/useActions'
import { selectPreferences, selectThreshold } from '../../../../../Redux/selectors/selectors'
import { debounce, sortedOrderPositionsFromObj } from '../../../../../helpers/helpers'
import styles from './ColorsControl.module.scss'
import stylesPref from '../../../Preferences.module.scss'
import ActionsOrder from './ActionsOrder'
import { useNameMapper } from '../../../../../hooks/useNameMapper'

export default function ColorsControlSection({
	title,
	subtitle = '',
	isDrawer = false,
	type,
	isShowAdvancedSettings = false,
	isAdvanced = false,
}) {
	const { dataNew } = useSelector(selectPreferences)
	const { isDrawReverseActions } = dataNew.common
	const dispatch = useDispatch()
	const settings = useCurrentTheme()
	const getLocale = useComponentLocale()
	const { setDrawReverseRaiseBetActions } = useActions()
	const namesMapper = useNameMapper()

	const thresholdLocale = getLocale({ component: 'theme', section: 'range_display_threshold' })

	const threshold = useSelector(selectThreshold)
	const [localThreshold, setLocalThreshold] = useState(threshold * 100)

	useEffect(() => {
		setLocalThreshold(threshold * 100)
	}, [threshold])

	let object
	switch (title) {
		case 'actions':
			object = settings.actions
			break
		case 'matrix':
			object = settings.matrix
			break
		case 'suits':
			object = settings.cards.suits
			break
		case 'positions':
			object = sortedOrderPositionsFromObj(settings.positions)
			break
		case 'equity':
			object = settings.matrix.equity
			break
		case 'eqr':
			object = settings.matrix.eqr
			break
		case 'ev':
			object = settings.matrix.ev
			break
		case 'range':
			object = settings.matrix.range
			break
		case 'textColor':
			object = settings.matrix.textColor
			break
		case 'substrate':
			object = {
				textcolor1playermatrix: settings.matrix.substrate.textcolor1playermatrix,
				textcolor2playermatrix: settings.matrix.substrate.textcolor2playermatrix,
			}
			break
		case 'trainer':
			object = { table: settings.trainer.table, chip: settings.trainer.chip }
			break
	}

	const checkboxHandler = (value) => {
		setDrawReverseRaiseBetActions(value)
	}

	const setAbsThresholdDebounce = useCallback(
		debounce((value) => {
			dispatch(setAbsThreshold(value / 100))
		}, 1000),
		[]
	)

	const onChangeAbsThreshold = (value) => {
		const regexp = /^0\d+/
		if (regexp.test(String(value))) {
			return false
		}
		if (value >= 0 && value <= 100) {
			// dispatch(setAbsThreshold(value))
			setLocalThreshold(value)
			setAbsThresholdDebounce(value)
		}

		return false
	}

	return (
		<div className={styles.mainWrapper}>
			{isDrawer && title !== 'textColor' && <h3>{getLocale({ component: 'theme', section: title })}</h3>}

			{Object.entries(object).map(([name, value], index) => {
				// for regular values
				if (typeof value === 'string') {
					return (
						<ColorPickerControl
							color={value}
							key={index}
							pickerLabel={name in namesMapper ? namesMapper[name] : name}
							onColorPicked={(hex) => {
								dispatch(setNewPreferences(name, hex, type ? type : title, title))
							}}
							position={subtitle}
						/>
					)
				}

				if (title === 'actions') {
					return (
						<>
							<div style={{ marginBottom: 32 }}>
								{object.raise.map((item, index) => (
									<ColorPickerControl
										color={item}
										key={index}
										pickerLabel={`Bet/Raise ${index + 1}`}
										onColorPicked={(hex) => dispatch(setRaisesColors(hex, index))}
										position={subtitle}
									/>
								))}
							</div>

							{isDrawer && (
								<>
									<ActionsOrder />

									<div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
										<Switch
											checked={isDrawReverseActions}
											onChange={checkboxHandler}
											size='small'
											className={
												isDrawReverseActions ? stylesPref.switchButtonChecked : stylesPref.switchButtonNotChecked
											}
										/>

										<Typography className='switch-title'>Revert actions order in graphic elements</Typography>
									</div>

									<Input
										value={localThreshold}
										addonBefore={thresholdLocale}
										placeholder='0-100 %'
										style={{ width: 270, marginBottom: '16px', marginTop: '8px' }}
										size='middle'
										maxLength={100}
										onChange={(e) => onChangeAbsThreshold(e.target.value)}
									/>
								</>
							)}
						</>
					)
				}
			})}
		</div>
	)
}
